import { connect } from 'formik';
import FormikError from './FormikError';

export default connect(FormikError);
